import styled from 'styled-components'
import { Card } from '../atoms/Card/card-styles'
import { DefaultFontStyle } from '../../styles/global-styles'
import { NavLink } from 'react-router-dom'

export const ParentBanner = styled.div`
  margin: 30px;
`

export const HeaderContainer = styled.div`
  padding: 10px 15px 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    padding: 15px 48px 25px;
  }
`

export const Logo = styled.img`
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    width: 136px;
  }
`

export const UserImg = styled.img`
  position: relative;
  width: 85px;
  height: 85px;
  border-radius: 50%;
  filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.25));
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    width: 50px;
    height: 50px;
  }
`

export const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  color: ${props => props.theme.colours.black};
  &:hover,
  &:focus,
  &:active {
    cursor: pointer;
  }
`

export const StyledSpan = styled.span`
  text-align: center;
`

export const UserIcon = styled.div`
  width: 85px;
  height: 85px;
  background: #fb3f4a;
  border-radius: 50%;
  position: relative;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.colours.white};
  display: flex;
  font-size: 24px;
  font-weight: 300;
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    width: 50px;
    height: 50px;
  }
`

export const DropDown = styled(Card)`
  display: none;
  flex-direction: column;
  gap: 20px;
  ${DefaultFontStyle};
  position: absolute;
  top: 112px;
  right: 13px;
  background: ${props => props.theme.colours.white};
  box-shadow: 0px 4px 100px rgba(0, 0, 0, 0.12);
  padding: 15px 35px;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: black;
  &:before {
    content: '';
    left: calc(50% - 7px);
    top: -7px;
    position: absolute;
    background: ${props => props.theme.colours.white};
    border: 7px solid white;
    transform: rotate(45deg);
  }
`

export const SignOut = styled.div`
  cursor: pointer;
  &:hover {
    ${DropDown} {
      display: flex;
      transition-duration: 1s;
    }
  }
`
export const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
`
